import React from 'react'
import './App.css'
import { Provider } from 'react-redux'
import store from './store/store'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import HomeScreen from './components/HomeScreen'
import UserScreen from './components/UserScreen'
import TutorLessonScreenWrapper from './components/TutorLessonScreenWrapper'
import UnitsScreen from './components/UnitsScreen'
import UnitScreen from './components/UnitScreen'
import LessonPlanScreen from './components/LessonPlanScreen'
import ExercisesScreen from './components/ExercisesScreen'
import ResetPasswordScreen from './components/ResetPasswordScreen'
import NewPasswordScreen from './components/NewPasswordScreen'
import LessonFinishedScreen from './components/LessonFinishedScreen'

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" Component={HomeScreen} />
          <Route path="/lesson/:lessonId/:debug?" Component={TutorLessonScreenWrapper} />
          <Route path="/lesson-finished" Component={LessonFinishedScreen} />
          <Route path="/user" Component={UserScreen} />
          <Route path="/units" Component={UnitsScreen} />
          <Route path="/units/:unitId" Component={UnitScreen} />
          <Route path="/units/:unitId/lesson_plans/:lessonPlanId" Component={LessonPlanScreen} />
          <Route path="/units/:unitId/lesson_plans/:lessonPlanId/exercises" Component={ExercisesScreen} />
          <Route path="/reset-password" Component={ResetPasswordScreen} />
          <Route path="/reset-password/:secureId" Component={NewPasswordScreen} />
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default App
